import React from 'react';
import Responsive from 'react-responsive';

export const Desktop = (props) => <Responsive {...props} query="(min-width: 992px) and (orientation: landscape), (min-height: 992px) and (orientation: portrait)" />;
export const Mobile = (props) => <Responsive {...props} query="(max-width: 991px) and (orientation: landscape), (max-height: 991px) and (orientation: portrait)"/>;